var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{ref:"grid",staticClass:"grid"},[_c('div',{staticClass:"grid-sizer"}),_vm._v(" "),_vm._l((_vm.content.pieces),function(piece,i){return _c('hub-item',{key:piece.title,staticClass:"grid-item",class:_vm.sizeClass(i),attrs:{"piece":piece,"reveal":_vm.id},on:{"layout":_vm.layout}})})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ef9fc3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Hub.vue
// module id = 95
// module chunks = 0